module.exports = __webpack_public_path__ + "static/soziales1-4b8f08d61344843b13c674bc199515ed.png";